/* KartComms — Support page. Search (FAQ + guides), category filter, single-open accordion,
   and a no-reload contact form with honeypot. Content is fully visible without JS. */
(function () {
  'use strict';
  var root = document.getElementById('kc-support');
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- search + category filter ---------- */
  var search = root.querySelector('[data-search]');
  var faqItems = Array.prototype.slice.call(root.querySelectorAll('.kcs-q'));
  var articleItems = Array.prototype.slice.call(root.querySelectorAll('.kcs-card'));
  var faqEmpty = root.querySelector('[data-faq-empty]');
  var artEmpty = root.querySelector('[data-article-empty]');
  var cats = Array.prototype.slice.call(root.querySelectorAll('.kcs-cat'));
  var clearBtn = root.querySelector('[data-clear-cat]');
  var activeCat = '';
  var query = '';

  function txt(el) { return (el.textContent || '').toLowerCase(); }

  function apply() {
    var q = query.trim();
    var faqVisible = 0;
    faqItems.forEach(function (el) {
      var okCat = !activeCat || el.getAttribute('data-cat') === activeCat;
      var okQ = !q || txt(el).indexOf(q) > -1;
      var show = okCat && okQ;
      el.hidden = !show;
      if (show) faqVisible++;
    });
    if (faqEmpty) faqEmpty.hidden = faqVisible !== 0;

    var artVisible = 0;
    articleItems.forEach(function (el) {
      var show = !q || txt(el).indexOf(q) > -1;   // guides filter by search only
      el.hidden = !show;
      if (show) artVisible++;
    });
    if (artEmpty) artEmpty.hidden = artVisible !== 0;
    if (clearBtn) clearBtn.hidden = !activeCat;
  }

  if (search) search.addEventListener('input', function () { query = search.value.toLowerCase(); apply(); });

  cats.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-cat');
      if (activeCat === key) { activeCat = ''; btn.classList.remove('is-active'); }
      else {
        activeCat = key;
        cats.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        var faq = document.getElementById('kcs-faq');
        if (faq) faq.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
      apply();
    });
  });
  if (clearBtn) clearBtn.addEventListener('click', function () {
    activeCat = ''; cats.forEach(function (b) { b.classList.remove('is-active'); }); apply();
  });

  /* ---------- accordion: one open at a time + smooth height ---------- */
  faqItems.forEach(function (d) {
    var summary = d.querySelector('summary');
    var panel = d.querySelector('.kcs-q__a');
    if (!summary || !panel) return;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      var willOpen = !d.open;
      // close siblings
      if (willOpen) {
        faqItems.forEach(function (o) { if (o !== d && o.open) closePanel(o); });
      }
      willOpen ? openPanel(d) : closePanel(d);
    });
  });
  function openPanel(d) {
    var panel = d.querySelector('.kcs-q__a');
    d.open = true;
    if (reduce) return;
    var h = panel.scrollHeight;
    panel.style.height = '0px';
    requestAnimationFrame(function () { panel.style.transition = 'height .3s cubic-bezier(.16,1,.3,1)'; panel.style.height = h + 'px'; });
    panel.addEventListener('transitionend', function done() { panel.style.transition = ''; panel.style.height = ''; panel.removeEventListener('transitionend', done); });
  }
  function closePanel(d) {
    var panel = d.querySelector('.kcs-q__a');
    if (reduce) { d.open = false; return; }
    var h = panel.scrollHeight;
    panel.style.height = h + 'px';
    requestAnimationFrame(function () { panel.style.transition = 'height .3s cubic-bezier(.16,1,.3,1)'; panel.style.height = '0px'; });
    panel.addEventListener('transitionend', function done() { d.open = false; panel.style.transition = ''; panel.style.height = ''; panel.removeEventListener('transitionend', done); });
  }

  /* ---------- contact form: honeypot + no-reload submit ---------- */
  var form = root.querySelector('[data-kcs-form]');
  if (form) {
    var serverOk = form.querySelector('[data-form-ok]');
    if (serverOk) serverOk.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });

    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('input[name="contact[website]"]');
      if (hp && hp.value) { e.preventDefault(); return; }          // bot
      if (!form.checkValidity()) return;                            // let browser show field errors + native submit
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
      fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
        .then(function () {
          var grid = form.querySelector('[data-form-fields]');
          var ok = document.createElement('p');
          ok.className = 'kcs-form__ok';
          ok.setAttribute('role', 'status');
          ok.textContent = form.getAttribute('data-success') || 'Thanks — your message is in.';
          form.insertBefore(ok, grid);
          if (grid) grid.classList.add('is-hidden');
          ok.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        })
        .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } form.submit(); });
    });
  }
})();
